'use strict'

import _find from 'lodash/find'

import template from './create.template.pug'

class CreateUserController {
  constructor(
    $mdSidenav,
    customer,
    users,
    tasksites,
    $mdMedia,
    $state,
    $mdDialog,
    $scope,
    $stateParams,
    SessionService,
    $mdToast,
  ) {
    'ngInject'
    Object.assign(
      this,
      {
        $mdSidenav,
        customer,
        users,
        tasksites,
        $mdMedia,
        $state,
        $mdDialog,
        $scope,
        $stateParams,
        SessionService,
        $mdToast,
      },
      {
        userData: {},
        email: null,
      },
    )
  }

  setUserData(userData) {
    console.log('userData', userData)
    this.userData = userData
  }

  cancel() {
    this.$mdDialog.cancel()
  }

  checkMail() {
    const user = _find(this.users, (u) => u.user.email === this.email)
    if (!user) {
      this.createForm.email.$setValidity('owner', true)
      this.createForm.email.$setValidity('exists', true)
    } else {
      this.createForm.email.$setTouched(true)
      if (user.isOwner(this.customer.no)) this.createForm.email.$setValidity('owner', false)
      else this.createForm.email.$setValidity('exists', false)
    }
  }

  save() {
    if (this.userData.admin) this.postAdmin()
    else this.postPermissions()
  }

  postAdmin() {
    this.customer
      .createAdmin({
        email: this.email,
        reports: this.userData.reports,
        documents: this.userData.documents,
      })
      .then(() => this.handleSuccess(`${this.email} wurde erfolgreich hinzugefügt.`))
  }

  postPermissions() {
    this.customer
      .createPermissions({
        email: this.email,
        permissions: this.userData.tasksites.map((t) => {
          return { tasksiteId: t }
        }),
      })
      .then(() => this.handleSuccess(`${this.email} wurde erfolgreich hinzugefügt.`))
  }

  handleSuccess(msg) {
    this.$state.reload().then(() => {
      this.$mdDialog.hide()
      const toast = this.$mdToast.simple().textContent(msg).action('OK').position('bottom').hideDelay(10000)
      this.$mdToast.show(toast)
    })
  }
}

export const createUserComponent = {
  controller: CreateUserController,
  controllerAs: '$ctrl',
  clickOutsideToClose: false,
  escapeToClose: true,
  template: template(),
  fullscreen: true,
}

export const createUserConfig = ($mdDialogProvider) => {
  'ngInject'

  $mdDialogProvider.addPreset('createUser', {
    options: () => {
      return createUserComponent
    },
  })
}



// WEBPACK FOOTER //
// ./app/users/containers/create/create.component.js